@if (getLoading$() | async) {
  <div class="loading-panel text-center">
    <mat-spinner class="track" mode="indeterminate" value="100" [diameter]="35"></mat-spinner>

    <div class="text-center">
      {{ loadingMessage$() | async | abpLocalization }}
    </div>
  </div>
}

@if (modal) {
  <div class="k-overlay"></div>
}
